import cls from "classnames"
import { useCallback, useMemo } from "react"

import { i18n } from "@/i18n"
import { useModalStore, usePercent } from "@/store"
import StrokeText from "../StrokeText"

import styles from "./index.module.scss"

export const ProgressBar: React.FC = () => {
    const percent = usePercent()

    const numbers = useMemo(() => {
        return String(percent).split("")
    }, [percent])

    const openSkin = useModalStore((state) => state.openSkin)
    const openLetter = useModalStore((state) => state.openLetter)

    const handleClickLetter = useCallback(() => {
        if (percent >= 100) {
            openLetter()
        }
    }, [openLetter])

    return (
        <div className={styles.progressBar}>
            <div className={styles.bar}>
                <div
                    className={styles.barInner}
                    style={{ height: `${percent}%` }}
                />
            </div>
            <div className={styles.layer}>
                <div className={styles.label}>
                    {i18n.get("map.progress.label")}
                </div>
                <div className={styles.current}>
                    {numbers.map((number, index) => (
                        <StrokeText
                            key={index}
                            text={number}
                            fontFamily="Trajan-Bold"
                            fontSize={43}
                            fillColor="#fff"
                            borderWidth={3}
                            borderColor="#5c3e1c"
                            offsetY={0}
                            padding={3}
                            baselineAligned
                            className={styles.number}
                        />
                    ))}
                    <StrokeText
                        text="%"
                        fontFamily="Trajan-Bold"
                        fontSize={31}
                        fillColor="#fff"
                        borderWidth={3}
                        borderColor="#5c3e1c"
                        offsetY={0}
                        padding={3}
                        baselineAligned
                        className={styles.text}
                    />
                </div>
                <div
                    className={styles.reward}
                    data-percent={50}
                    onClick={openSkin}
                >
                    <div
                        className={cls(
                            styles.img,
                            percent >= 50 && styles.completed,
                        )}
                    />
                    <div className={styles.percent}>
                        <span>{i18n.get("map.progress.reward")}</span>
                    </div>
                    <div className={cls(styles.name, styles.skin)}>
                        {i18n
                            .get("map.reward.skin")
                            .split("\n")
                            .map((line, index) => (
                                <StrokeText
                                    key={index}
                                    text={line}
                                    fontFamily="source-han-sans-japanese"
                                    fontWeight={500}
                                    fontSize={20}
                                    fillColor="#2e220b"
                                    borderWidth={2}
                                    borderColor="#ffffff"
                                    offsetY={0}
                                    padding={3}
                                    className={styles.text}
                                />
                            ))}
                    </div>
                </div>
                <div
                    className={styles.reward}
                    data-percent={100}
                    onClick={handleClickLetter}
                >
                    <div
                        className={cls(
                            styles.img,
                            percent >= 100 && styles.completed,
                        )}
                    />
                    <div className={styles.percent}>
                        <span>{i18n.get("map.progress.reward")}</span>
                    </div>
                    <div className={styles.name}>
                        <StrokeText
                            text={i18n.get("map.reward.letter")}
                            fontFamily="source-han-sans-japanese"
                            fontWeight={500}
                            fontSize={20}
                            fillColor="#2e220b"
                            borderWidth={2}
                            borderColor="#ffffff"
                            offsetY={0}
                            padding={3}
                            className={styles.text}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
